export default { KKN_VERSION:"1.5.0.1"}